
  import {defineComponent, defineExpose, ref, watch} from 'vue';
  import request from '@/utils/request'
  export default defineComponent({
    name:'ui-table',
    props:{
      data:{
        type:Array,
      },
      url:{
        type:String,
      },
      search:{
        type:Object,
      },
      rowKey:{
        type:String
      },
      expendAll:{
        type:Boolean,
        default:false
      },
      selectable:{
        type:Function
      },
      isNeedSelect:{
        type:Boolean,
        default:false
      },
      isNeedIndex:{
        type:Boolean,
        default:false
      }

    },
    emits:['onSearch','onReset','handleSelectionChange','changePage'],
    setup(props,ctx){
      interface HeaderStyle{
        background:string,
        color:string
      }
      let tableHeight = ref(window.innerHeight - 435)
      let params:any = ref([])
      let total:any = ref(0)
      let page:any = ref("1")
      watch(props.search,(newValue,oldValue) => {
        getList()
      })
      function getList():void{
       let url = props.url
       let data = {
         pageSize: 10,
         page:page.value,
         ...props.search
       }
       request({
         url:props.url.toString(),
         method: 'get',
         params:data
        }).then(res => {
            console.log(res.data)
         params.value = res.data
         total.value = res["totalRecords"]
        })
      }
      getList()
      function setHeaderStyle():HeaderStyle{
        return {background:'#F2F5F9',color:'#001B4B'}
      }
      function onSearch():void{
        getList()
      }
      function onReset():void{
        ctx.emit('onReset')
      }
      function handleSelectionChange(val:any):void{
        ctx.emit('handleSelectionChange',val)
      }
      function changePage(val:any):void{
        page.value = val
        getList()
      }
      defineExpose({getList})
      return {
        params,
        total,
        page,
        tableHeight,
        setHeaderStyle,
        onSearch,
        onReset,
        handleSelectionChange,
        changePage,
        getList

      }
    },
  })
